import {camelCase, snakeCase} from "lodash/string";

export const apiUrlRegexp = /REACT_APP_([A-Z_]+?)_API_URL/;
export const lambdaUrlRegexp = /REACT_APP_([A-Z_]+?)_LAMBDA_URL/;

console.log(process.env)
const prod = {
    app: {
        BASE_URL: 'https://enable.busable.app'
    },
    s3: {
        REGION: "ap-southeast-2",
        BUCKET: "prod-busable-storagestack-busablebucketfa6d3fb9-o3vold4lv08y",
    },
    apiGateway: {
        REGION: "ap-southeast-2",
        WSS: "wss://n77u4aibx5.execute-api.ap-southeast-2.amazonaws.com/prod",
        TRACKABLE_WSS: 'wss://uil74wktr6.execute-api.ap-southeast-2.amazonaws.com/prod',
        API: {
            endpoints: [
                {
                    name: "routes",
                    endpoint: "https://sxoj421pu6.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "transfer",
                    endpoint: "https://av7d8d9xh9.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "driver",
                    endpoint: "https://akse038jjf.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "vehicle",
                    endpoint: "https://5p7xyfo542.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'shift_bat', endpoint: " https://40fucnjss8.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'deadrun', endpoint: "https://vfpgey8c2l.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'ref', endpoint: "https://h7nrfb8auk.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'log', endpoint: "https://j2on6o67j9.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'events', endpoint: "https://i5rh3rfj3g.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "third_party",
                    endpoint: "https://felv930otc.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "operators",
                    endpoint: "https://zzywf9q68c.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "student",
                    endpoint: "https://cyolwv6n85.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "sms",
                    endpoint: "https://p3v3susjp1.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "charter",
                    endpoint: "https://998g15uy23.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "public",
                    endpoint: "https://u6mcv8i5ae.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "job",
                    endpoint: "https://2003evks4i.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "customer",
                    endpoint: "https://x28lac080h.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "vehicleType",
                    endpoint: "https://3bfukhja61.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "shift",
                    endpoint: "https://wjqpozpeh3.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "roster",
                    endpoint: "https://ntw386e1ck.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "tracking",
                    endpoint: "https://zkkk0rjmzh.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "report",
                    endpoint: "https://kdw7y4jbz9.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "schedules",
                    endpoint: "https://7bx7hpkdr8.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "booking",
                    endpoint: "https://wdrnx0vqdl.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "public_schedules",
                    endpoint: "https://m6c2pcow32.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "block",
                    endpoint: "https://1hmi6d13rb.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "xero",
                    endpoint: "https://x622p00foi.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "v2",
                    endpoint: "https://ozsc8qaen3.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                }
            ]
        }
    },
    cognito: {
        REGION: "ap-southeast-2",
        USER_POOL_ID: "ap-southeast-2_BWWYMNFJR",
        APP_CLIENT_ID: "620gaq44su0img4tf7ljts2c89",
        IDENTITY_POOL_ID: "ap-southeast-2:728ac1f6-ef9a-4418-accd-6f179ad8e45e",
    },
    maps: {
        google: "AIzaSyCSHdLuk1GVtKxYnv-uAdIOPTR-j52w4v0",
        here: {
            apiKey: "9qrlZt0tavW3Uefrqxtb5arMvaRXfSiumLDTB2IwUGo",
        },
        KEY: "AIzaSyCqhZ56-F0-1I313GCXuBOYUztCNLGUAdg",
        mabBox: "pk.eyJ1IjoiZ2pyd2ViYmVyIiwiYSI6ImNrcmx5bmd3YzJxdWcycG00Mm1ydGEwcGUifQ.hzLzm-bpjB2Nci43izcg-A",
        geoapify: {
            ctrxs: "0139accdc5d84b5084289bccffa2a90d",
            blpctn: "837db0932a254b9584923c6a36e3fdf2",
            bldbbo: "8d4ff339b5a44c289accee1a595d7a6e",
            bltmwrth: "4f3326f97be04107abe7207ae1dc9960",
            blbthrst: "5fa71575daf94f328e85a69c384cb41e"
        }
    },
    lambda: {
        toGtfs: {
            URL: "https://tklvd5ovi5gnl2vu2ht5ut3dju0cnzne.lambda-url.ap-southeast-2.on.aws"
        },
        uploadGtfs: {
            URL: "https://aswixtsitleivrfpjzid4rx3j40shhln.lambda-url.ap-southeast-2.on.aws"
        }
    },
    email: {
        ELASTIC_EMAIL_KEY: 'EFDA288C1FDDD78446AA5C2DE2F5521E15E2B011B988FFDADC68056155EFD00745ABF7730FB2F40D4644E3262B05C9FE'
    },
    cms: {
        URL: 'https://cms.busable.app',
        APIKEY: 'ba3b1e8c6ea3fa120b493347332570bf8143cd8eaec62cb6d2e8c455282b3c7000a0381336eddc4d04e3ba6371f431b644b054ea3dc4bf68ef6388235b3fbf888b513a189eed9cd44116354f86df7ba4ffd573732686fb3df1753447fbfe379659326f62b1613729ca3140c6bb4b8c9ab77cad43137f71897687628ca314b7e9'
    },
    zight: {
        apiKey: '2c484fab-de9c-4c58-b706-3dd75e1d592e',
        apiEndpoint: 'https://api.zight.com/v1'
    },
    jira: {
        projectKey: 'BUS',
        jiraApiToken: 'ATATT3xFfGF0Ylqw9pYvvXGVrK3XdtL4QYEjiTtoB4i0ffzjpdkiQIxek-bvsZVBikWym-OdFmZ0-B7pwtA8YYzFufXMKp2_1k3ZTRQRT5QmpWXwoabxs5JyTjAdNEqz4jEV9fS0GlcKH76m6TMnGiB_lSdtvyICuyb8_kabjR9HL3vLsYWt464=91D15CEE',
        jiraEmail: 'avindu@busable.app',
        enabled: true // Set to true to enable JIRA ticket creation
    }
};
const staging = {
    app: {
        BASE_URL: 'http://localhost:3000'
    },
    s3: {
        REGION: "ap-southeast-2",
        BUCKET: "staging-busable-storagestac-busablebucketfa6d3fb9-1217nxj03z054",
    },
    apiGateway: {
        REGION: "ap-southeast-2",
        WSS: "wss://22n0u0z9h5.execute-api.ap-southeast-2.amazonaws.com/staging",
        TRACKABLE_WSS: 'wss://jeaggqhnwf.execute-api.ap-southeast-2.amazonaws.com/staging',
        API: {
            endpoints: [
                {
                    name: "routes",
                    endpoint: "https://rdgalzct76.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "transfer",
                    endpoint: "https://pn5dvssax1.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "driver",
                    endpoint: "https://a61dzgd9ik.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "vehicle",
                    endpoint: "https://oah8v3beq5.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'shift_bat', endpoint: "https://wazkd6j6m0.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'deadrun', endpoint: "https://0ytldz973k.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'ref', endpoint: "https://kuaieusjl2.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'log', endpoint: "https://4w392a7tv9.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'events', endpoint: "https://42i6q6s6r0.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "third_party",
                    endpoint: "https://tfzc9w7uu6.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "operators",
                    endpoint: "https://cigccenqsg.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "student",
                    endpoint: "https://w16cqtmxa2.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "sms",
                    endpoint: "https://jq1cil20d0.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "charter",
                    endpoint: "https://calof04jl1.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "public",
                    endpoint: "https://kq8lc7hjfi.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "job",
                    endpoint: "https://47ck9ee9da.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "customer",
                    endpoint: "https://dbx60wmuue.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "vehicleType",
                    endpoint: "https://dky01hqrb4.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "shift",
                    endpoint: "https://erwtfbmfn9.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "roster",
                    endpoint: "https://nsjvt1h9y1.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "tracking",
                    endpoint: "https://h0mqs6ktsh.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "report",
                    endpoint: "https://9a3mm51nh0.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "schedules",
                    endpoint: "https://pn06ed82rf.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "booking",
                    endpoint: "https://c6q79s97u5.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "block",
                    endpoint: "https://b286sauzw4.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "public_schedules",
                    endpoint: "https://i3oj8ilk53.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "xero",
                    endpoint: "https://eoyr0a48y8.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "v2",
                    endpoint: "https://gst80a1h1f.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                }
            ]
        }
    },
    cognito: {
        REGION: "ap-southeast-2",
        USER_POOL_ID: "ap-southeast-2_BWWYMNFJR",
        APP_CLIENT_ID: "620gaq44su0img4tf7ljts2c89",
        IDENTITY_POOL_ID: "ap-southeast-2:f775397e-bdde-4c86-b6f0-6197e1f77c84",
    },
    maps: {...prod.maps},
    lambda: {
        toGtfs: {
            URL: "https://nuvolqh4amxasdjfue2vukpsjy0svzko.lambda-url.ap-southeast-2.on.aws"
        },
        uploadGtfs: {
            URL: "https://zfplugmor6jvt3vbx2cf6svc7e0lhwum.lambda-url.ap-southeast-2.on.aws"
        }
    },
    email: {
        ELASTIC_EMAIL_KEY: 'EFDA288C1FDDD78446AA5C2DE2F5521E15E2B011B988FFDADC68056155EFD00745ABF7730FB2F40D4644E3262B05C9FE'
    },
    cms: {
        URL: 'http://localhost:1337',
        APIKEY: '2399f748d5984084bcd586494173fca082ffa23fa0543785c24dd48c2cfdab9a2257cc4bb4ee7c4d4bf04bca62a34b042fc3db90a6bcaa7ff18d3813fa2c1143e0de9ab246e39c0e97d6f01afb2294949b32db73f2437fcec77292c26c7a1085385e0c354d42abe051c2c789308f761f8e1cb9ed78a3710f2f9e84ce8a70fdbb'
    },
    zight: {
        apiKey: '2c484fab-de9c-4c58-b706-3dd75e1d592e',
        apiEndpoint: 'https://api.zight.com/v1'
    },
    jira: {
        projectKey: 'BUS',
        jiraApiToken: 'ATATT3xFfGF0Ylqw9pYvvXGVrK3XdtL4QYEjiTtoB4i0ffzjpdkiQIxek-bvsZVBikWym-OdFmZ0-B7pwtA8YYzFufXMKp2_1k3ZTRQRT5QmpWXwoabxs5JyTjAdNEqz4jEV9fS0GlcKH76m6TMnGiB_lSdtvyICuyb8_kabjR9HL3vLsYWt464=91D15CEE',
        jiraEmail: 'avindu@busable.app',
        enabled: true // Set to true to enable JIRA ticket creation
    }
};

const pilot = {
    app: {
        BASE_URL: 'http://localhost:3000'
    },
    s3: {
        REGION: "ap-southeast-2",
        BUCKET: "pilot-busable-storagestack-busablebucketfa6d3fb9-tsyans9kctmc",
    },
    apiGateway: {
        REGION: "ap-southeast-2",
        WSS: "wss://0boylvfs00.execute-api.ap-southeast-2.amazonaws.com/pilot",
        API: {
            endpoints: [
                {
                    name: "routes",
                    endpoint: "https://h6vxoapgd3.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "transfer",
                    endpoint: "https://p5cjr4fnmc.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "driver",
                    endpoint: "https://pp9gbw8d8a.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "vehicle",
                    endpoint: "https://pkd7262wy4.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'shift_bat', endpoint: "https://z73d7jatol.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'deadrun', endpoint: "https://0cvxz9f5ec.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'ref', endpoint: "https://rc1auezh8f.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'log', endpoint: "https://mr075cpfy4.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'events', endpoint: "https://ndss1e58vh.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "third_party",
                    endpoint: "https://iut9ccwilc.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "operators",
                    endpoint: "https://vd9mi5oz5k.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "students",
                    endpoint: "https://w16cqtmxa2.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "sms",
                    endpoint: "https://jq1cil20d0.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "charter",
                    endpoint: "https://gklcj2cfu9.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "public",
                    endpoint: "https://kq8lc7hjfi.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "job",
                    endpoint: "https://47ck9ee9da.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "vehicleType",
                    endpoint: "https://dky01hqrb4.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "report",
                    endpoint: "https://9a3mm51nh0.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "schedules",
                    endpoint: "https://i3oj8ilk53.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "booking",
                    endpoint: "https://c6q79s97u5.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "public_schedules",
                    endpoint: "https://i3oj8ilk53.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "xero",
                    endpoint: "https://eoyr0a48y8.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                }
            ]
        }
    },
    cognito: {
        REGION: "ap-southeast-2",
        USER_POOL_ID: "ap-southeast-2_BWWYMNFJR",
        APP_CLIENT_ID: "620gaq44su0img4tf7ljts2c89",
        IDENTITY_POOL_ID: "ap-southeast-2:0cc18ed2-137c-406e-a293-8f48b0b687de",
    },
    maps: {...prod.maps},
    lambda: {
        toGtfs: {
            URL: "https://4ih244bj3nhlnzshw5w6bnnjza0tdnpa.lambda-url.ap-southeast-2.on.aws"
        },
    },
    email: {
        ELASTIC_EMAIL_KEY: 'EFDA288C1FDDD78446AA5C2DE2F5521E15E2B011B988FFDADC68056155EFD00745ABF7730FB2F40D4644E3262B05C9FE'
    },
    cms: {
        URL: 'http://localhost:1337',
        APIKEY: '2399f748d5984084bcd586494173fca082ffa23fa0543785c24dd48c2cfdab9a2257cc4bb4ee7c4d4bf04bca62a34b042fc3db90a6bcaa7ff18d3813fa2c1143e0de9ab246e39c0e97d6f01afb2294949b32db73f2437fcec77292c26c7a1085385e0c354d42abe051c2c789308f761f8e1cb9ed78a3710f2f9e84ce8a70fdbb'
    },
    zight: {
        apiKey: '2c484fab-de9c-4c58-b706-3dd75e1d592e',
        apiEndpoint: 'https://api.zight.com/v1'
    },
    jira: {
        projectKey: 'BUS',
        jiraApiToken: 'ATATT3xFfGF0Ylqw9pYvvXGVrK3XdtL4QYEjiTtoB4i0ffzjpdkiQIxek-bvsZVBikWym-OdFmZ0-B7pwtA8YYzFufXMKp2_1k3ZTRQRT5QmpWXwoabxs5JyTjAdNEqz4jEV9fS0GlcKH76m6TMnGiB_lSdtvyICuyb8_kabjR9HL3vLsYWt464=91D15CEE',
        jiraEmail: 'avindu@busable.app',
        enabled: true // Set to true to enable JIRA ticket creation
    }

};


const preview = {
    ...prod,
    s3: {
        REGION: "ap-southeast-2",
        BUCKET: "develop-busable-storagestac-busablebucketfa6d3fb9-1jsl2lx39d1k5",
    },
    apiGateway: {
        REGION: "ap-southeast-2",
        WSS: "wss://w1xrjyue80.execute-api.ap-southeast-2.amazonaws.com/preview",
        TRACKABLE_WSS: 'wss://6067blydjj.execute-api.ap-southeast-2.amazonaws.com/preview',
        API: {
            endpoints: [
                {
                    name: "routes",
                    endpoint: "https://mqkqpm4nal.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "transfer",
                    endpoint: "https://zbw90ejcj1.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "driver",
                    endpoint: "https://ht6qaet3ni.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "vehicle",
                    endpoint: "https://xw71mp2s50.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'shift_bat', endpoint: "https://9bef1rbuw9.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'deadrun', endpoint: "https://kux2hlxy84.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'ref', endpoint: "https://8ejfeueuac.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'log', endpoint: "https://okwzdhdlh1.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'events', endpoint: "https://elox5w4uw7.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "third_party",
                    endpoint: "https://yavvo57ne9.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "operators",
                    endpoint: "https://imquq1leza.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "students",
                    endpoint: "https://w16cqtmxa2.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "sms",
                    endpoint: "https://lr1jsyuj00.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "charter",
                    endpoint: "https://xv9elsr324.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "public",
                    endpoint: "https://5alfuqx6bc.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "job",
                    endpoint: "https://vwom3jqxee.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "vehicleType",
                    endpoint: "https://9bdhjjiv86.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "report",
                    endpoint: "https://30piow4lvk.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "booking",
                    endpoint: "https://1uxlqmowrh.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "public_schedules",
                    endpoint: "https://e49rqgm4yg.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "xero",
                    endpoint: "https://v9tmb436xd.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "route",
                    endpoint: "https://o1p4k4b9s1.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "gtfs",
                    endpoint: "https://j4ajes9prg.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "shift",
                    endpoint: "https://at81783a7h.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "schedules",
                    endpoint: "https://22hemoyqnj.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "block",
                    endpoint: "https://aqg9wo1qa2.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "roster",
                    endpoint: "https://udvum24000.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "tracking",
                    endpoint: "https://j7zsjte5ug.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "customer",
                    endpoint: "https://gopejgohse.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "student",
                    endpoint: "https://3e88rq8naf.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
            {
                name: "vehicle_type",
                endpoint: "https://9bdhjjiv86.execute-api.ap-southeast-2.amazonaws.com",
                region: "ap-southeast-2"
            }]
        }
    },
    cognito: {
        ...prod.cognito,
        IDENTITY_POOL_ID: "ap-southeast-2:7dfe5e1a-db2c-4215-b5f2-2e5383701946",
    },
    maps: {...prod.maps},
    lambda: {
        toGtfs: {
            URL: "https://vyb2umlcacrojj7z567ikehiee0cwqdr.lambda-url.ap-southeast-2.on.aws"
        },
    },
    xero: {
        defaultClientId: '4353A1A6C1564D628F3D1CE94DB92B24',
        defaultClientSecret: 'jip6z3QzstG8LBfxtKp7XOV5qL5-na1x5vsNhVOBqE4M08lN'
    }
};

const develop = {
    app: {
        BASE_URL: 'http://localhost:3000'
    },
    s3: {
        REGION: "ap-southeast-2",
        BUCKET: "develop-busable-storagestac-busablebucketfa6d3fb9-1jsl2lx39d1k5",
    },
    apiGateway: {
        REGION: "ap-southeast-2",
        WSS: "wss://hvfy6wlwt0.execute-api.ap-southeast-2.amazonaws.com/develop",
        API: {
            endpoints: [
                {
                    name: "routes",
                    endpoint: "https://je0w3mlxqd.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "transfer",
                    endpoint: "https://n3tsmibaml.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "driver",
                    endpoint: "https://xt0301vkqf.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "vehicle",
                    endpoint: "https://5jbr4usw03.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'shift_bat', endpoint: "https://7t983smkbf.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'deadrun', endpoint: "https://q5y1izvpd1.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'ref', endpoint: "https://2q4n53akjj.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'log', endpoint: "https://xbq6ntxa67.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: 'events', endpoint: "https://bhx7i6d24i.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "third_party",
                    endpoint: "https://tsgf73v8cg.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "operators",
                    endpoint: "https://vljb52kmca.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "students",
                    endpoint: "https://w16cqtmxa2.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "sms",
                    endpoint: "https://q5y1izvpd1.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "charter",
                    endpoint: "https://q5y1izvpd1.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "public",
                    endpoint: "https://kq8lc7hjfi.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "job",
                    endpoint: "https://47ck9ee9da.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "vehicleType",
                    endpoint: "https://dky01hqrb4.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "report",
                    endpoint: "https://9a3mm51nh0.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "booking",
                    endpoint: "https://c6q79s97u5.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "public_schedules",
                    endpoint: "https://i3oj8ilk53.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                },
                {
                    name: "xero",
                    endpoint: "https://eoyr0a48y8.execute-api.ap-southeast-2.amazonaws.com",
                    region: "ap-southeast-2"
                }
            ]
        }
    },
    cognito: {
        REGION: "ap-southeast-2",
        USER_POOL_ID: "ap-southeast-2_EdE8ekw42",
        APP_CLIENT_ID: "3bifrb5tm0f1tkhg8rhffgjonq",
        IDENTITY_POOL_ID: "ap-southeast-2:ca3b0223-bf53-4e84-ac9b-5cde4f3a40b8",
    },
    maps: {...prod.maps},
    lambda: {
        toGtfs: {
            URL: "https://vyb2umlcacrojj7z567ikehiee0cwqdr.lambda-url.ap-southeast-2.on.aws"
        },
    },
    email: {
        ELASTIC_EMAIL_KEY: 'EFDA288C1FDDD78446AA5C2DE2F5521E15E2B011B988FFDADC68056155EFD00745ABF7730FB2F40D4644E3262B05C9FE'
    },
    cms: {
        URL: 'http://localhost:1337',
        APIKEY: '2399f748d5984084bcd586494173fca082ffa23fa0543785c24dd48c2cfdab9a2257cc4bb4ee7c4d4bf04bca62a34b042fc3db90a6bcaa7ff18d3813fa2c1143e0de9ab246e39c0e97d6f01afb2294949b32db73f2437fcec77292c26c7a1085385e0c354d42abe051c2c789308f761f8e1cb9ed78a3710f2f9e84ce8a70fdbb'
    },
    zight: {
        apiKey: '2c484fab-de9c-4c58-b706-3dd75e1d592e',
        apiEndpoint: 'https://api.zight.com/v1'
    },
    jira: {
        projectKey: 'BUS',
        jiraApiToken: 'ATATT3xFfGF0Ylqw9pYvvXGVrK3XdtL4QYEjiTtoB4i0ffzjpdkiQIxek-bvsZVBikWym-OdFmZ0-B7pwtA8YYzFufXMKp2_1k3ZTRQRT5QmpWXwoabxs5JyTjAdNEqz4jEV9fS0GlcKH76m6TMnGiB_lSdtvyICuyb8_kabjR9HL3vLsYWt464=91D15CEE',
        jiraEmail: 'avindu@busable.app',
        enabled: true // Set to true to enable JIRA ticket creation
    }

};
export const dev = {
    app: {
        BASE_URL: 'http://localhost:3000',
    },
    s3: {
        REGION: process.env.REACT_APP_REGION,
        BUCKET: process.env.REACT_APP_BUCKET,
    },
    apiGateway: {
        REGION: process.env.REACT_APP_REGION,
        WSS: process.env.REACT_APP_WSS_URL,
        API: {
            endpoints: Object.keys(process.env).filter(envKey => envKey.match(apiUrlRegexp)).map(envKey => {
                const match = envKey.match(apiUrlRegexp)
                return {
                    name: snakeCase(match[1]),
                    endpoint: process.env[envKey],
                    region: process.env.REACT_APP_REGION
                }
            })
        },
        TRACKABLE_WSS: 'wss://axo0t14wde.execute-api.ap-southeast-2.amazonaws.com/staging'
    },
    cognito: {
        REGION: process.env.REACT_APP_REGION,
        USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
        APP_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID,
        IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID,
    },
    maps: {...prod.maps},
    lambda: {},
    email: {
        ELASTIC_EMAIL_KEY: 'EFDA288C1FDDD78446AA5C2DE2F5521E15E2B011B988FFDADC68056155EFD00745ABF7730FB2F40D4644E3262B05C9FE'
    },
    cms: {
        URL: 'http://localhost:1337',
        APIKEY: '2399f748d5984084bcd586494173fca082ffa23fa0543785c24dd48c2cfdab9a2257cc4bb4ee7c4d4bf04bca62a34b042fc3db90a6bcaa7ff18d3813fa2c1143e0de9ab246e39c0e97d6f01afb2294949b32db73f2437fcec77292c26c7a1085385e0c354d42abe051c2c789308f761f8e1cb9ed78a3710f2f9e84ce8a70fdbb'
    },
    zight: {
        apiKey: '5daf17bb-ebbe-49e9-8284-3a029ad26967',
        apiEndpoint: 'https://api.zight.com/v1'
    },
    jira: {
        projectKey: 'BUS',
        jiraApiToken: 'ATATT3xFfGF0Ylqw9pYvvXGVrK3XdtL4QYEjiTtoB4i0ffzjpdkiQIxek-bvsZVBikWym-OdFmZ0-B7pwtA8YYzFufXMKp2_1k3ZTRQRT5QmpWXwoabxs5JyTjAdNEqz4jEV9fS0GlcKH76m6TMnGiB_lSdtvyICuyb8_kabjR9HL3vLsYWt464=91D15CEE',
        jiraEmail: 'avindu@busable.app',
        enabled: true // Set to true to enable JIRA ticket creation
    }

};
Object.keys(process.env).filter(envKey => lambdaUrlRegexp.test(envKey)).forEach(envKey => {
    const match = envKey.match(lambdaUrlRegexp)
    dev.lambda[camelCase(match[1])] = {URL: process.env[envKey].slice(0, -1)}
})

const local = {
    local: true,
    ...staging
}

const configs = {local, staging, preview, dev, develop, pilot, prod}

console.log(`Config: ${process.env.REACT_APP_STAGE || dev}`)

// if (process.env.REACT_APP_STAGE && !configs[process.env.REACT_APP_STAGE]) {
//     throw new Error(process.env.REACT_APP_STAGE + ` is not usable. ${Object.keys(configs)} are the only stages that work.`)
// }

const config = {
    MAX_ATTACHMENT_SIZE: 2000000,
    ...(configs[process.env.REACT_APP_STAGE] || configs.dev),
};

config.getApiGatewayUrl = (endpointName) => {
    const api = config.apiGateway.API.endpoints.find(endpoint => endpoint.name === endpointName).endpoint;
    if(!api?.length) {
        throw new Error(`Endpoint ${endpointName} not found in apiGateway.API.endpoints`);
    }
    return api;
}

console.log(configs[process.env.REACT_APP_STAGE] || configs.dev)
export default config;
